// GeneralTab.tsx
import { Box, Grid, Typography } from '@mui/material'
import { fileUrl } from 'api/api'
import { InventoryTabs } from 'features/warehouses/inventory/form-inventory'
import { FilesType } from 'features/warehouses/inventory/inventory'
import { useTranslation } from 'react-i18next'
import { numberFormat } from 'utils/app.utils'

export default function GeneralTab(props: InventoryTabs) {
    const { t } = useTranslation()
    const { inventory: inventoryObj } = props

    // 1. สร้าง array เดียวจากข้อมูลทุกฟิลด์ (ละทิ้ง DOCUMENT หรือจะเอาเข้ามาด้วยก็ได้)
    const allFields = inventoryObj.group === 'MEDICINE'
        ? [
            { key: 'CODE', item: inventoryObj.itemCode || '-' },
            { key: 'TYPE', item: inventoryObj.itemTypeName || inventoryObj.itemTypeNameEn || '-' },
            { key: 'INSTRUCTION', item: inventoryObj.productInstructionName || '-' },
            { key: 'UNIT', item: inventoryObj.itemUnitName || inventoryObj.itemUnitNameEn || '-' },
            { key: 'USES', item: inventoryObj.productUseDetail || '-' },
            { key: 'FORMAT', item: inventoryObj.productFormatName || '-' },
            { key: 'STRENGTH', item: inventoryObj.strength || '-' },
            { key: 'WARNING', item: inventoryObj.warnings || '-' },

            { key: 'PRESERVE', item: inventoryObj.productPreserveName || '-' },
            { key: 'PRICE', item: `${numberFormat(inventoryObj.costPrice || 0)} ${t('CURRENCY_CHANGE.TH')}` },
            { key: 'SELL', item: `${numberFormat(inventoryObj.price || inventoryObj.salePrice || 0)} ${t('CURRENCY_CHANGE.TH')}` },
            { key: 'MIN_QTY', item: inventoryObj.minStock || 0 },
            { key: 'EXPIRED', item: inventoryObj.amounDayBeforeExpired || '-' },
            { key: 'DESCRIPTION', item: inventoryObj.explanation || '-' },
        ]
        : [
            { key: 'CODE', item: inventoryObj.itemCode || '-' },
            { key: 'TYPE', item: inventoryObj.itemTypeName || inventoryObj.itemTypeNameEn || '-' },
            { key: 'INSTRUCTION', item: inventoryObj.productInstructionName || '-' },
            { key: 'UNIT', item: inventoryObj.itemUnitName || inventoryObj.itemUnitNameEn || '-' },
            { key: 'PRESERVE', item: inventoryObj.productPreserveName || '-' },
            { key: 'PRICE', item: `${numberFormat(inventoryObj.costPrice || 0)} ${t('CURRENCY_CHANGE.TH')}` },

            { key: 'SELL', item: `${numberFormat(inventoryObj.price || inventoryObj.salePrice || 0)} ${t('CURRENCY_CHANGE.TH')}` },
            { key: 'MIN_QTY', item: inventoryObj.minStock || 0 },
            { key: 'EXPIRED', item: inventoryObj.amounDayBeforeExpired || '-' },
            { key: 'DESCRIPTION', item: inventoryObj.explanation || '-' },
        ]

    // 2. แบ่งครึ่ง
    const half = Math.ceil(allFields.length / 2)   // ถ้า 14 รายการ → half = 7
    const leftFields = allFields.slice(0, half)
    const rightFields = allFields.slice(half)

    // 3. ฟังก์ชันแสดงไฟล์ (ถ้ามี)
    const renderFiles = (file?: FilesType) => {
        if (file?.fileName && file.filePath) {
            const path = `${fileUrl}/${file.filePath}/${file.fileName}`
            return (
                <Box display="flex">
                    <Typography pr={1}>•</Typography>
                    <Typography
                        onClick={() => window.open(path)}
                        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        {file.fileName}
                    </Typography>
                </Box>
            )
        }
        return null
    }

    // 4. แสดงผลโดย map ทีเดียว
    return (
        <Grid container spacing={2}>
            {leftFields.map((left, idx) => {
                const right = rightFields[idx]  // ถ้า idx >= rightFields.length จะเป็น undefined
                return (
                    <Grid container item spacing={3} key={idx}>
                        {/* คอลัมน์ซ้าย */}
                        <Grid item xs={12} md={6} display={'flex'} flexBasis={'row'} spacing={3}>
                            <Grid item xs={12} md={6}> <Typography variant="subtitle2" fontWeight={500}>{t(`INVENTORY.FORM.${inventoryObj.group}.${left.key}`)}</Typography></Grid>
                            <Grid item xs={12} > {left.key === 'DOCUMENT' && Array.isArray(left.item) ? left.item.map((file, i) => <Box key={i}>{renderFiles(file)}</Box>) : <Typography variant="body2">{left.item}</Typography>}</Grid>
                        </Grid>

                        {/* คอลัมน์ขวา */}
                        {right && (
                            <Grid item xs={12} md={6} display={'flex'} flexBasis={'row'} spacing={3}>
                                <Grid item xs={12} md={6}> <Typography variant="subtitle2" fontWeight={500}>
                                    {t(`INVENTORY.FORM.${inventoryObj.group}.${right.key}`)}
                                </Typography></Grid>
                                <Grid item xs={12} > {right.key === 'DOCUMENT' && Array.isArray(right.item)
                                    ? right.item.map((file, i) => <Box key={i}>{renderFiles(file)}</Box>)
                                    : <Typography variant="body2">{right.item}</Typography>
                                }</Grid>
                            </Grid>
                        )}
                    </Grid>
                )
            })}
        </Grid>
    )
}
